import { IconCheckCircle } from '@components/icons/icon-check-circle';
import { IconLoading } from '@components/icons/icon-loading';
import { ProgressLine } from '@components/progress-line';

import { BatchProgressProps } from './batch-progress.type';

export const BatchProgress = ({ completed, total, label, isFinished = false }: BatchProgressProps) => {
  const percentage = total > 0 ? Math.round((completed / total) * 100) : 0;

  return (
    <div className='flex flex-col items-center gap-6' data-testid='batch-progress'>
      {isFinished ? (
        <IconCheckCircle className='w-9 h-9 text-success-no-bg' />
      ) : (
        <IconLoading className='w-9 h-9 animate-spin text-tertiary' />
      )}
      {label && <p className='text-subtitle-m text-primary text-center'>{label}</p>}
      <div className='flex flex-col gap-2 w-full'>
        <ProgressLine percentageProgress={percentage} heightClassName='h-1' borderRadiusClassName='' />
        <div className='flex justify-between text-body-xs text-tertiary'>
          <span>
            {completed} / {total}
          </span>
          <span>{percentage}%</span>
        </div>
      </div>
    </div>
  );
};
